import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

export const PinMessage = ({ sxProps }: { sxProps?: SxProps }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', color: 'secondary.main', ...sxProps }}
  >
    <path d="m13.828 1.686 8.486 8.485-1.415 1.415-.707-.707-4.242 4.242-.707 3.536-1.415 1.413-4.242-4.242-4.95 4.95-1.414-1.415 4.95-4.95-4.243-4.242 1.414-1.414L8.88 8.05l4.242-4.242-.707-.707 1.414-1.415h-.001Zm.708 3.536-4.671 4.67-2.822.565 6.5 6.5.564-2.823 4.671-4.67-4.242-4.242Z" />
  </SvgIcon>
)
PinMessage.defaultProps = {
  sxProps: null,
}
